/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  Ratings reducer
 */

import { falseReducer, nullReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { RatingsLTR } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CLEAR_RATINGS,
  DONE_FETCHING_RATINGS,
  ERROR_FETCHING_RATINGS,
  RECEIVE_RATINGS,
  START_FETCHING_RATINGS,
} from '../constants/index'
import type { ActionTypes } from './types'

export const ratingsReducer = combineReducers<RatingsLTR, ActionTypes>({
  data: handleActions<RatingsLTR['data'], ActionTypes>(
    {
      [RECEIVE_RATINGS]: payloadReducer,
      [CLEAR_RATINGS]: nullReducer,
    },
    null
  ),
  meta: combineReducers<RatingsLTR['meta'], ActionTypes>({
    error: handleActions<RatingsLTR['meta']['error'], ActionTypes>(
      {
        [ERROR_FETCHING_RATINGS]: trueReducer,
        [CLEAR_RATINGS]: falseReducer,
        [START_FETCHING_RATINGS]: falseReducer,
      },
      false
    ),
    fetching: handleActions<RatingsLTR['meta']['fetching'], ActionTypes>(
      {
        [START_FETCHING_RATINGS]: trueReducer,
        [CLEAR_RATINGS]: falseReducer,
        [DONE_FETCHING_RATINGS]: falseReducer,
      },
      false
    ),
  }),
})
